module.exports = __webpack_public_path__ + "static/media/icn_link.4e22e890.svg";